<app-login-content-container>

  <div class="error-container">
    {{'password_expired.reset_password_msg' | translate}}
  </div>

  @if (errorMessage) {
    <div class="error-container">
      {{this.errorMessage}}
    </div>
  }
  <!-- <app-alert-message-box [errorMessage] = "'password_expired.reset_password_msg' | translate" ></app-alert-message-box>

  <app-alert-message-box *ngIf="errorMessage" [errorMessage] = "errorMessage" ></app-alert-message-box>
  -->
  <app-change-password-form (changePassword)="onChangePassword($event)"
  [buttonLoading]="buttonLoading" [hideCurrentPassword]="true"></app-change-password-form>

</app-login-content-container>